import { render, staticRenderFns } from "./ModelADRJDiv.vue?vue&type=template&id=6c5757b1&scoped=true&"
import script from "./ModelADRJDiv.vue?vue&type=script&lang=js&"
export * from "./ModelADRJDiv.vue?vue&type=script&lang=js&"
import style0 from "./ModelADRJDiv.vue?vue&type=style&index=0&id=6c5757b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5757b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardText,VIcon})
